import React, { memo, useCallback, useMemo } from 'react';
import { QuickFilters } from '@Sage/ssm-web5';

import { getLiteral } from 'utils/getLiteral';

const FILTER_IDS = ['businessType', 'radius'];

const LeadsQuickFilters = ({
    category,
    categoryOptions,
    radiusKm,
    radiusOptions,
    businessTypesLoading,
    businessTypesError,
    onChangeCategory,
    onChangeRadiusKm,
}) => {
    const schema = useMemo(
        () => [
            {
                id: 'businessType',
                label: getLiteral('label_leads_business_type'),
                isRemovable: false,
                fields: [
                    {
                        id: 'businessType',
                        label: getLiteral('label_leads_business_type'),
                        dataType: 'singleValueList',
                        inputProps: {
                            options: categoryOptions,
                            isClearable: false,
                            isDisabled: Boolean(businessTypesLoading || businessTypesError),
                        },
                    },
                ],
            },
            {
                id: 'radius',
                label: getLiteral('label_leads_radius'),
                isRemovable: false,
                fields: [
                    {
                        id: 'radius',
                        label: getLiteral('label_leads_radius'),
                        dataType: 'singleValueList',
                        inputProps: {
                            options: radiusOptions,
                            isClearable: false,
                        },
                    },
                ],
            },
        ],
        [businessTypesError, businessTypesLoading, categoryOptions, radiusOptions],
    );

    const values = useMemo(
        () => ({
            businessType: categoryOptions.find((item) => item.value === category),
            radius: radiusOptions.find((item) => item.value === radiusKm),
        }),
        [category, categoryOptions, radiusKm, radiusOptions],
    );

    const handleChange = useCallback(
        ({ filter, value }) => {
            if (filter.id === 'businessType') onChangeCategory(value?.value ?? '');
            if (filter.id === 'radius') onChangeRadiusKm(value?.value || '2');
        },
        [onChangeCategory, onChangeRadiusKm],
    );

    return (
        <QuickFilters
            className="fm-leads-modal__quick-filters"
            filters={FILTER_IDS}
            schema={schema}
            values={values}
            onChange={handleChange}
            showAdd={false}
        />
    );
};

export default memo(LeadsQuickFilters);
